   <template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>
          <strong>Сторисы онбординга "{{ onboarding.title }}"</strong>
        </CCardHeader>
        <CCardBody>
          <OnboardingTabLinks />
          <div class="d-flex justify-content-end mb-2">
            <CButton color="primary" @click="openCreateModal">Добавить сторис</CButton>
          </div>
          <div class="table__preloader" v-if="loading">
            <CSpinner color="primary" />
          </div>
          <template v-else>
            <table class="table table-hover mt-3">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Название</th>
                  <th>Изображение</th>
                  <th>Позиция</th>
                  <th>Действия</th>
                </tr>
              </thead>
              <draggable
                tag="tbody"
                v-model="stories"
                @end="onDragEnd"
                handle=".handle"
              >
                <tr v-for="story in stories" :key="story.id">
                  <td class="align-middle">
                    <div class="w-16 d-flex align-items-center">
                      <CIcon
                        :height="16"
                        :content="cilCursorMove"
                        class="handle cursor-move mr-2"
                      />
                      <span>{{ story.position }}</span>
                    </div>
                  </td>
                  <td>{{ story.title }}</td>
                  <td>
                    <img
                      v-if="story.image"
                      :src="getImageUrl(story.image)"
                      alt="Story Image"
                      class="story-image"
                    />
                  </td>
                  <td>{{ story.position }}</td>
                  <td>
                    <CButton
                      color="info"
                      size="sm"
                      @click="openEditModal(story)"
                    >
                      Редактировать
                    </CButton>
                    <CButton
                      color="danger"
                      size="sm"
                      @click="deleteStory(story.id)"
                    >
                      Удалить
                    </CButton>
                  </td>
                </tr>
              </draggable>
            </table>
          </template>
        </CCardBody>
      </CCard>
    </CCol>

    <CModal :show.sync="showModal" :title="modalTitle" :footer="false">
      <div slot="body-wrapper" class="modal-body">
        <form>
          <div class="form-group">
            <label for="title">Название</label>
            <input
              id="title"
              v-model="currentStory.title"
              type="text"
              class="form-control"
              required
            />
          </div>

          <div class="form-group">
            <label for="image">Изображение</label>
            <div v-if="currentStory.image">
              <img
                :src="getImageUrl(currentStory.image)"
                alt="Current Image"
                class="current-image"
              />
            </div>
            <input
              type="file"
              @change="selectImage"
              class="form-control-file"
            />
          </div>

          <div class="form-group">
            <label for="title_button">Заголовок кнопки</label>
            <input
              id="title_button"
              v-model="currentStory.title_button"
              type="text"
              class="form-control"
            />
          </div>

          <div class="form-group">
            <label for="color_button">Цвет кнопки</label>
            <input
              id="color_button"
              v-model="currentStory.color_button"
              type="text"
              class="form-control"
              placeholder="#FFFFFF"
            />
          </div>

          <div class="form-group">
            <label>
              <input
                type="checkbox"
                v-model="currentStory.enabled_button"
              />
              Включить кнопку
            </label>
          </div>

          <div v-if="hasButtonLink" class="form-group">
            <label for="link_button">Ссылка кнопки</label>
            <input
              id="link_button"
              v-model="currentStory.link_button"
              type="text"
              class="form-control"
            />
          </div>

          <div class="form-group">
            <label>Действие кнопки:</label>
            <CCol sm="9" class="col-form-label">
                <CSelect
                    inline
                    :value.sync="currentStory.link_type"
                    :options="linkTypes" />
            </CCol>
            <small v-if="currentStory.link_type === 'request_notifications'" class="form-text text-muted">
              Повторно запрашивает разрешение на уведомления. Показ системного окна зависит от текущего разрешения на устройстве.
            </small>
            <small v-if="currentStory.link_type === 'authorize'" class="form-text text-muted">
              Открывает авторизацию. Родительский промокод для подарка выбирается в настройках онбординга.
            </small>
        </div>
        </form>
      </div>
      <div slot="footer">
        <CButton color="primary" @click="saveStory">{{
          isEdit ? 'Сохранить' : 'Создать'
        }}</CButton>
        <CButton color="secondary" @click="closeModal">Отмена</CButton>
      </div>
    </CModal>
  </CRow>
</template>

<script>
import {
  CRow,
  CCol,
  CCard,
  CCardHeader,
  CCardBody,
  CButton,
  CSpinner,
  CModal,
  CIcon
} from '@coreui/vue';
import Vue from 'vue';
import draggable from 'vuedraggable';
import { cilCursorMove } from '@coreui/icons';
import OnboardingTabLinks from '@/components/onboarding/OnboardingTabLinks';

export default {
  components: {
    CRow,
    CCol,
    CCard,
    CCardHeader,
    CCardBody,
    CButton,
    CSpinner,
    CModal,
    CIcon,
    draggable,
    OnboardingTabLinks,
  },
  data() {
    return {
      onboarding: {},
      stories: [],
      loading: true,
      showModal: false,
      isEdit: false,
      modalTitle: '',
      currentStory: {},
      selectedImage: null,
      cilCursorMove,
      linkTypes: [
        {
            label: 'Ничего',
            value: 'none',
        },
        {
            label: 'Ссылка на страницу',
            value: 'link',
        },
        {
            label: 'Внешняя ссылка',
            value: 'external_link',
        },
        {
            label: 'Запросить уведомления',
            value: 'request_notifications',
        },
        {
            label: 'Авторизоваться',
            value: 'authorize',
        },
      ],
    };
  },
  computed: {
    hasButtonLink() {
      return !['request_notifications', 'authorize'].includes(this.currentStory.link_type);
    },
  },
  created() {
    this.fetchOnboarding();
    this.fetchStories();
  },
  methods: {
    async fetchOnboarding() {
      try {
        const response = await this.axios.get(`/onboarding/${this.$route.params.id}`);
        this.onboarding = response.data;
      } catch (error) {
        this.$root.$emit('showError', 'Ошибка загрузки онбординга.');
      }
    },
    async fetchStories() {
      try {
        const response = await this.axios.get(
          `/onboarding/${this.$route.params.id}/stories`
        );
        this.stories = response.data;
      } catch (error) {
        this.$root.$emit('showError', 'Ошибка загрузки сторисов.');
      } finally {
        this.loading = false;
      }
    },
    openCreateModal() {
      this.isEdit = false;
      this.modalTitle = 'Создать сторис';
      this.currentStory = {
        onboarding_id: +this.$route.params.id,
        title: '',
        enabled: true,
        position: this.stories.length + 1,
        image: '',
        title_button: '',
        color_button: '',
        enabled_button: false,
        link_button: '',
        link_type: 'none',
      };
      this.selectedImage = null;
      this.showModal = true;
    },
    openEditModal(story) {
      this.isEdit = true;
      this.modalTitle = 'Редактировать сторис';
      this.currentStory = { ...story };
      this.selectedImage = null;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    selectImage(event) {
      this.selectedImage = event.target.files[0];
    },
    getImageUrl(filename) {
      return process.env.VUE_APP_STATIC_BASE_URL + '/' + filename;
    },
    async saveStory() {
      try {
        if (!this.currentStory.title) {
          this.$root.$emit('showError', 'Укажите название сториса.');
          return;
        }

        if (this.selectedImage) {
          let formData = new FormData();
          formData.append('file', this.selectedImage);
          const uploadResponse = await Vue.axios.post('/files/upload', formData);
          this.currentStory.image = uploadResponse.data.filename;
        }

        this.currentStory.enabled_button = !!this.currentStory.enabled_button;
        if (!this.hasButtonLink) {
          this.currentStory.link_button = '';
        }

        if (this.isEdit) {
          await this.axios.put(`/onboarding_stories/${this.currentStory.id}`, this.currentStory);
        } else {
          await this.axios.post('/onboarding_stories', this.currentStory);
        }
        await this.fetchStories();
        this.closeModal();
      } catch (error) {
        this.$root.$emit('showError', 'Ошибка сохранения сториса.');
      }
    },
    async deleteStory(id) {
      if (confirm('Вы уверены, что хотите удалить этот сторис?')) {
        try {
          await this.axios.delete(`/onboarding_stories/${id}`);
          await this.fetchStories();
        } catch (error) {
          this.$root.$emit('showError', 'Ошибка удаления сториса.');
        }
      }
    },
    async onDragEnd() {
      try {
        for (let i = 0; i < this.stories.length; i++) {
          this.stories[i].position = i + 1;
          await this.axios.put(`/onboarding_stories/${this.stories[i].id}`, {
            position: this.stories[i].position,
          });
        }
        await this.fetchStories();
      } catch (error) {
        this.$root.$emit('showError', 'Ошибка обновления порядка сторисов.');
      }
    },
  },
};
</script>

<style scoped>
.table__preloader {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}
.story-image,
.current-image {
  max-width: 100px;
  max-height: 100px;
}
.cursor-move {
  cursor: move;
}
</style>
